// Tabela "Se a economia fosse investida" — cenários × períodos.
// Recebe `scenarios` (3 cenários do calculateFinancialAnalysis) e os `periods`.

import type { CSSProperties } from "react";
import type { InvestmentScenario } from "@/lib/financial-analysis";

export interface QuoteInvestmentScenariosProps {
  scenarios: InvestmentScenario[];
  periods: number[];
  className?: string;
  style?: CSSProperties;
}

function brl(v: number) {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    maximumFractionDigits: 0,
  }).format(v);
}

export function QuoteInvestmentScenarios({
  scenarios,
  periods,
  className,
  style,
}: QuoteInvestmentScenariosProps) {
  if (!scenarios.length) return null;
  return (
    <div className={className} style={style}>
      <div
        style={{
          fontSize: "12px",
          fontWeight: 600,
          marginBottom: "6px",
          color: "#0f172a",
        }}
      >
        Se a economia fosse investida
      </div>
      <div
        style={{
          border: "1px solid #e5e7eb",
          borderRadius: "6px",
          overflow: "hidden",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "11px",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#f1f5f9" }}>
              <th
                style={{
                  textAlign: "left",
                  padding: "8px 10px",
                  fontWeight: 600,
                  color: "#475569",
                }}
              >
                Período
              </th>
              {scenarios.map((s) => (
                <th
                  key={s.label}
                  style={{
                    textAlign: "right",
                    padding: "8px 10px",
                    fontWeight: 600,
                    color: "#475569",
                  }}
                >
                  {s.label}{" "}
                  <span style={{ color: "#94a3b8", fontWeight: 400 }}>
                    ({Math.round(s.annualRate * 100)}%)
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {periods.map((year, idx) => (
              <tr
                key={year}
                style={{
                  borderTop: "1px solid #e5e7eb",
                  backgroundColor: idx % 2 === 0 ? "#ffffff" : "#f8fafc",
                }}
              >
                <td
                  style={{
                    padding: "8px 10px",
                    fontWeight: 500,
                    color: "#0f172a",
                  }}
                >
                  {year} anos
                </td>
                {scenarios.map((s) => (
                  <td
                    key={s.label}
                    style={{
                      padding: "8px 10px",
                      textAlign: "right",
                      fontWeight: 600,
                      color: "#16a34a",
                    }}
                  >
                    {brl(s.results[year] ?? 0)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
